import { IUserAlert } from "./interfaces/user-alert.interface";

export class UserAlert implements IUserAlert {
    public success: boolean;
    public message: string;
    public dismissed: boolean;

  constructor(success: boolean = false, message: string = "", dismissed: boolean = true) {
        this.success = success;
        this.message = message;
        this.dismissed = dismissed;
    }
}
